class CommercialTermsPermissions {
    constructor({ enabled = false, show = true } = {}) {
        this.enabled = enabled
        this.show = show
    }
}

export default CommercialTermsPermissions
